import React, { Component } from 'react';
import Table from '~/components/Table';

class Penalties extends Component {
  render() {
    return (
      <div className='penalties-wrapper'>
        <h3 className='penalties-title site-border-color'>Penalties</h3>
        { this.props.penalties.length > 0 ? 
          <Table 
            headers={this.props.headers[0]}
            data={this.props.penalties}
            values={this.props.headers[1]}
          /> :
          <div className='not-yet'>No penalties yet.</div> 
        }
      </div>
    )
  }
}

export default Penalties;